import TimeListDaTaOutputReportLayout from './TimeListDaTaOutputReportLayout';

export default TimeListDaTaOutputReportLayout;
